/**
 * Import lib & config
 */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import t from 'theme';

/**
 * Import components
 */

/**
 * styled components
 */

const Subtitle = styled.p`
  margin-bottom: 30px;
  font-weight: ${t.font.regular};
  font-family: ${t.font.primary};
  ${t.mixins.rem(16, 26)}
  ${t.mixins.sm(`
    ${t.mixins.rem(13, 19)}
  `)}
  color: ${(props) => props.color || t.color.black};
`;

/**
 * A text components
 */

const Content__subtitle = ({ style, children, color }) => (
  <Subtitle style={style} color={color}>{children}</Subtitle>
);


Content__subtitle.propTypes = {
  /**
    A custom style object
    */
  chContent: PropTypes.string,
  /**
    A children object to render content inside the components
    */
  color: PropTypes.string,

  /**
    A children object to render content inside the components
    */
  style: PropTypes.object,
};

Content__subtitle.defaultProps = {
  style: {},
  children: null,
  color: t.color.black,
};

export default Content__subtitle;
